import axios from "axios";
import {
  SUPPLIER_STATS_REQUEST,
  SUPPLIER_STATS_SUCCESS,
  SUPPLIER_STATS_FAIL,
  STATS_BY_AGE_REQUEST,
  STATS_BY_AGE_SUCCESS,
  STATS_BY_AGE_FAIL,
  STATS_CLIENTS_JOINED_PER_MONTH_REQUEST,
  STATS_CLIENTS_JOINED_PER_MONTH_SUCCESS,
  STATS_CLIENTS_JOINED_PER_MONTH_FAIL,
  STATS_NEW_ORDERS_PER_MONTH_REQUEST,
  STATS_NEW_ORDERS_PER_MONTH_SUCCESS,
  STATS_NEW_ORDERS_PER_MONTH_FAIL,
  TOP_PERFORMING_PRO_SUP_SER_COM_REQUEST,
  TOP_PERFORMING_PRO_SUP_SER_COM_SUCCESS,
  TOP_PERFORMING_PRO_SUP_SER_COM_FAIL,
  OVERALL_SUPPLIER_STATS_REQUEST,
  OVERALL_SUPPLIER_STATS_SUCCESS,
  OVERALL_SUPPLIER_STATS_FAIL,
} from "constants/statsConstants";
import StatsService from "services/stats-service";

export const getSupplierStats = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: SUPPLIER_STATS_REQUEST,
    });

    const res = await StatsService.getStats();
    console.log("🚀 ~ file: statsActions.js:16 ~ getSupplierStats ~ res:", res);

    dispatch({
      type: SUPPLIER_STATS_SUCCESS,
      payload: res.foundSupplierStats,
    });
  } catch (error) {
    dispatch({
      type: SUPPLIER_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

// export const getStatsByAge = () => async (dispatch, getState) => {
//   try {
//     dispatch({
//       type: STATS_BY_AGE_REQUEST,
//     });

//     const res = await StatsService.getStatsByAge();
//     console.log("🚀 ~ file: statsActions.js:46 ~ getStatsByAge ~ res:", res);

//     dispatch({
//       type: STATS_BY_AGE_SUCCESS,
//       payload: res.foundStatsByAge,
//     });
//   } catch (error) {
//     dispatch({
//       type: STATS_BY_AGE_FAIL,
//       payload:
//         error.response && error.response.data.message
//           ? error.response.data.message
//           : error,
//     });
//   }
// };

export const getStatsClientsJoinedPerMonth =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATS_CLIENTS_JOINED_PER_MONTH_REQUEST,
      });

      const res = await StatsService.getStatsClientsJoinedPerMonth();
      console.log(
        "🚀 ~ file: statsActions.js:73 ~ getStatsClientsJoinedPerMonth ~ res:",
        res
      );

      dispatch({
        type: STATS_CLIENTS_JOINED_PER_MONTH_SUCCESS,
        payload: res.foundStatsClientJoinedPerMonth,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: statsActions.js:80 ~ getStatsClientsJoinedPerMonth ~ error:",
        error
      );
      dispatch({
        type: STATS_CLIENTS_JOINED_PER_MONTH_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const getStatsNewOrdersPerMonth = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATS_NEW_ORDERS_PER_MONTH_REQUEST,
    });

    const res = await StatsService.getStatsNewOrdersPerMonth();
    console.log(
      "🚀 ~ file: statsActions.js:73 ~ getStatsNewOrdersPerMonth ~ res:",
      res
    );

    dispatch({
      type: STATS_NEW_ORDERS_PER_MONTH_SUCCESS,
      payload: res.foundStatsNewOrdersPerMonth,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: statsActions.js:80 ~ getStatsNewOrdersPerMonth ~ error:",
      error
    );
    dispatch({
      type: STATS_NEW_ORDERS_PER_MONTH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getTopPerformingProSupSerCom =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: TOP_PERFORMING_PRO_SUP_SER_COM_REQUEST,
      });

      const res = await StatsService.getTopPerformingProSupSerCom();
      console.log(
        "🚀 ~ file: statsActions.js:142 ~ getTopPerformingProSupSerCom ~ res:",
        res
      );

      dispatch({
        type: TOP_PERFORMING_PRO_SUP_SER_COM_SUCCESS,
        payload: res.foundTopPerformingProSupSerCom,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: statsActions.js:149 ~ getTopPerformingProSupSerCom ~ error:",
        error
      );
      dispatch({
        type: TOP_PERFORMING_PRO_SUP_SER_COM_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const getOverallSupplierStats = () => async (dispatch, getState) => {
  console.log(
    "🚀 ~ file: statsActions.js:43 ~ getOverallSupplierStats ~ start getting:"
  );

  try {
    dispatch({
      type: OVERALL_SUPPLIER_STATS_REQUEST,
    });

    const res = await StatsService.getOverallSupplierStats();
    console.log(
      "🚀 ~ file: statsActions.js:43 ~ getOverallSupplierStats ~ res:",
      res
    );

    dispatch({
      type: OVERALL_SUPPLIER_STATS_SUCCESS,
      payload: res.foundOverallSupplierStats,
    });
  } catch (error) {
    dispatch({
      type: OVERALL_SUPPLIER_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
